import { FC, lazy } from 'react';
import { Route, Routes as Switch } from 'react-router-dom';

import { ErrorCode } from '@/lib/apollo/types/gen/graphql';
import GlossaryInfoPage from '@/pages/Glossary/Info';

import BasicGuard from '../middlewares/BasicGuard';

const IndexPage = lazy(() => import('@/pages/Glossary'));
const GlossaryListPage = lazy(() => import('@/pages/Glossary/List'));

const ErrorPage = lazy(() => import('@/pages/Error'));

const GlossaryRoutes: FC = () => {
  return (
    <Switch>
      <Route
        index
        element={
          <BasicGuard>
            <IndexPage />
          </BasicGuard>
        }
      />
      <Route path={':initial/*'}>
        <Route
          index
          element={
            <BasicGuard>
              <GlossaryListPage />
            </BasicGuard>
          }
        />
        <Route
          path={':termName'}
          element={
            <BasicGuard>
              <GlossaryInfoPage />
            </BasicGuard>
          }
        />
      </Route>

      <Route
        path="*"
        element={<ErrorPage forceErrorCode={ErrorCode.NotFound} />}
      />
    </Switch>
  );
};

export default GlossaryRoutes;
